import Icon from "@components/ui/icon";
import { cn } from "@lib/cn";
import { useMemo, useRef, useState } from "react";
import { VIDEOS_PANEL_STOCK_CATEGORIES } from "../constants";
import { useStockVideosCtx } from "../ctx";
import { useStockStoreShallow } from "../store";

export const StockCategories = () => {
  const { view } = useStockVideosCtx();
  const { category, setCategory } = useStockStoreShallow((s) => ({
    category: s.category,
    setCategory: s.setCategory,
  }));
  const scrollableRef = useRef<HTMLDivElement | null>(null);
  const [scrollIdx, setScrollIdx] = useState(0);

  const scrollToStart = () => {
    const scrollableEl = scrollableRef.current;
    if (!scrollableEl) return;
    scrollableEl.scrollTo({
      behavior: "smooth",
      left: 0,
    });
  };

  const scrollToEnd = () => {
    const scrollableEl = scrollableRef.current;
    if (!scrollableEl) return;
    scrollableEl.scrollTo({
      behavior: "smooth",
      left: scrollableEl.scrollWidth,
    });
  };
  const categories = useMemo(() => {
    if (view === "dialog") {
      return VIDEOS_PANEL_STOCK_CATEGORIES.filter(
        (opt) => opt.key !== "ai_suggestions",
      );
    }
    return VIDEOS_PANEL_STOCK_CATEGORIES;
  }, []);

  return (
    <div className="tw-relative tw-overflow-hidden">
      <div
        className="no-scrollbar tw-snap-x tw-snap-mandatory tw-overflow-x-scroll"
        ref={scrollableRef}
        onScroll={(e) => {
          setScrollIdx(e.currentTarget.scrollLeft > 0 ? 1 : 0);
        }}
      >
        <ol className="tw-m-0 tw-inline-flex tw-list-none tw-grid-cols-[auto] tw-gap-1.5">
          {categories.map((opt) => (
            <li
              key={opt.key}
              onClick={() => setCategory(opt.key)}
              className={cn({
                "tw-flex tw-cursor-pointer tw-snap-center tw-items-center tw-text-nowrap tw-break-keep tw-rounded-md tw-px-2 tw-py-1 tw-text-[11px] tw-font-semibold tw-text-blue-600": true,
                "tw-bg-blue-100 tw-text-blue-800": category === opt.key,
              })}
            >
              {opt.key === "ai_suggestions" && (
                <Icon
                  icon="sd-ai-logo"
                  className={cn("tw-mr-1", {
                    "tw-fill-blue-600": category !== opt.key,
                    "tw-fill-blue-800": category === opt.key,
                  })}
                />
              )}
              {opt.label ?? opt.query}
            </li>
          ))}
        </ol>
      </div>

      <div
        className={cn({
          "tw-absolute tw-top-0 tw-h-full tw-w-6": true,
          "tw-right-0": scrollIdx === 0,
          "tw-left-0": scrollIdx > 0,
        })}
        style={{
          background: `linear-gradient(${scrollIdx === 0 ? 270 : 90}deg, #FFF 30%, rgba(255, 255, 255, 0.5) 100%)`,
        }}
      />

      <button
        onClick={scrollIdx === 0 ? scrollToEnd : scrollToStart}
        className={cn({
          "tw-absolute tw-top-1/2 tw-grid tw-size-4 -tw-translate-y-1/2 tw-place-items-center tw-outline-none": true,
          "tw-right-0": scrollIdx === 0,
          "tw-left-0": scrollIdx > 0,
        })}
      >
        <Icon
          icon={`ri-arrow-${scrollIdx === 0 ? "right" : "left"}-s-line`}
          className="tw-text-[16px]/none tw-text-blue-base"
        />
      </button>
    </div>
  );
};
